// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hLVvM","label":"styles_label__tUtyY"};